import React, { FC, Dispatch, useState } from 'react'; // useStateを追加
import NumberFormat from 'react-number-format';
import { Setting } from '../../App';
import classes from '../../asset/css/pickup/pickup-shipping-product-list.module.css';
import { useSubscriptionLine } from '../../hooks/use-subscription-line';
import { SubscriptionType } from '../../types/api/subscriptions-api-type';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../../types/view/recommend-product-info-view-type';

export const PickupProductItemPickup: FC<{
  productItem: ProductInfoViewType;
  loading: boolean;
  message?: string;
  setting: Setting;
  addProductSuccess: (showModal: boolean) => void;
  failed: (message: string) => void;
  setSubscriptionContractId: Dispatch<string>;
  setRegisteredProducts: Dispatch<ProductInfoViewType[]>;
  setPausedProducts: Dispatch<ProductInfoViewType[]>;
  setRecommendProducts: Dispatch<RecommendProductInfoViewType[]>;
  setSubscription: Dispatch<SubscriptionType>;
}> = ({
  productItem,
  loading,
  message,
  setting,
  addProductSuccess,
  failed,
  setSubscriptionContractId,
  setRegisteredProducts,
  setPausedProducts,
  setRecommendProducts,
  setSubscription,
}) => {
  // ローカルな状態を追加
  const [isAdding, setIsAdding] = useState(false);

  const priceBlock = (
    <span className={classes.item_info_content_priceBlock_current}>
      <small>割引価格</small> ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
    </span>
  );
  // productItem.originalPrice === productItem.price ? (
  //   <>
  //     <span className={classes.item_info_content_priceBlock_current}>
  //       ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
  //     </span>
  //   </>
  // ) : (
  //   <>
  //     <span className={classes.item_info_content_priceBlock_original}>
  //       ￥<NumberFormat displayType="text" value={productItem.originalPrice} thousandSeparator={true} />
  //     </span>
  //     <span className={classes.item_info_content_priceBlock_arrow}>→</span>
  //     <span className={classes.item_info_content_priceBlock_current}>
  //       ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
  //     </span>
  //   </>
  // );

  const messageBlock = message ? (
    <div className={classes.item_info_content_messageBlock}>
      <p className={classes.item_info_content_messageBlock_msg}>{message}</p>
      <div className={classes.item_info_content_messageBlock_avatar} />
    </div>
  ) : (
    <></>
  );

  const { addProduct } = useSubscriptionLine(setting, setSubscription);

  const handleAddToBox = () => {
    if (isAdding || loading) {
      // 既に処理中の場合は何もしない
      return;
    }

    setIsAdding(true); // 処理開始

    addProduct(
      productItem.planId!,
      productItem.variantId,
      1,
      () => {
        addProductSuccess(true);
        setIsAdding(false); // 処理完了
      },
      setSubscriptionContractId,
      setRegisteredProducts,
      setPausedProducts,
      setRecommendProducts,
      (errorMessage: string) => {
        failed(errorMessage);
        setIsAdding(false); // エラー時も処理完了
      }
    );
  };

  return (
    <li className={classes.item}>
      <a href={productItem.url} target="_blank" rel="noopener noreferrer" className={classes.item_thumbnail}>
        <div
          style={productItem.image ? { backgroundImage: `url('${productItem.image}')` } : {}}
          className={classes.item_thumbnail_img}
        />
      </a>

      <div className={classes.item_info}>
        {/* 商品名と価格 */}
        <div className={classes.item_info_titlePrice}>
          {/* 商品名 */}
          <h4 className={classes.item_info_title}>{productItem.productTitle}</h4>

          {/* 商品価格 */}
          <div className={classes.item_info_price}>{priceBlock}</div>
        </div>

        {/* アクションボタン */}
        <div className={classes.item_info_actions}>
          <button
            className={classes.item_info_actions_addBtn}
            disabled={loading || isAdding} // loadingまたはisAddingで無効化
            onClick={handleAddToBox}
          >
            {isAdding ? '追加中...' : 'BOXに追加'} {/* 状態に応じてボタンテキストを変更 */}
          </button>
        </div>
      </div>
    </li>
  );
};
